module.exports = __webpack_public_path__ + "media/แม่งโง่หรือฉลาดวะ.0fd76ac7.mp3";